// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__adelaila_711431', '__adelaila_Fallback_711431'"},"className":"__className_711431","variable":"__variable_711431"};